import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import RouteFallback from "../ui/RouteFallback";

const PrivateRoute = () => {
  const { token, authChecked } = useAuth();
  const location = useLocation();

  // Wait for the async session probe before deciding — otherwise a logged-in
  // user is bounced to /login on every hard refresh of a protected page.
  if (!authChecked) return <RouteFallback />;

  if (!token) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
